import React from "react";
import { Alert, Button, Typography } from "@picklebet/ui";
import { useGameSessions } from "@/features/casino/hooks/useGameSessions";
import { useShellStore } from "@/features/shell/stores/shellStore";

import * as styles from "./ActiveSessionAlert.module.scss";

/**
 * Casino funds are locked to the session, so a withdrawal cannot be requested
 * until it ends. The dialog the button opens is mounted globally by Layout.
 */
export const ActiveSessionAlert = () => {
  const { hasActiveGameSession } = useGameSessions(true);
  const setModal = useShellStore((state) => state.setModal);

  if (!hasActiveGameSession) {
    return null;
  }

  return (
    <Alert
      color="info"
      size="small"
      title="Unable to withdraw while there is an active Casino session."
    >
      <div>
        <Typography variant="body" noSpacing>
          End your active Casino session to access your funds.
        </Typography>
        <Button
          variant="info"
          size="sm"
          className={styles.endSession}
          onClick={() => setModal("endGameSession")}
        >
          End Session
        </Button>
      </div>
    </Alert>
  );
};
